export default __webpack_public_path__ + "static/media/sun_black_02-1.3be763e1.jpg";